module.exports = __webpack_public_path__ + "img/MTN-LOGO.17358324.svg";